import { setExperiencePlace } from 'actions/ExperienceActions'
import Places, { getDefaultRegionPlace } from 'constants/places'
import GeoContext from 'contexts/geoContext'
import useExperienceSearchList from 'hooks/Experiences/useExperienceSearchList'
import { useAppSelector, useAppDispatch } from 'hooks/reduxHooks'
import { usePlaceById, usePlaceByCoords } from 'hooks/usePlace'
import usePrevious from 'hooks/usePrevious'
import { getExperienceListOfferCount } from 'lib/experiences/experienceUtils'
import { useContext, useEffect } from 'react'

function useSmartExperiencePlace() {
  const geo = useContext(GeoContext)
  const experiencePlace = useAppSelector(state => state.experience.experiencePlace)
  // console.log(experiencePlace)
  const dispatch = useAppDispatch()

  const selectedPlace = usePlaceById(experiencePlace.placeId)
  const [geoPlace] = usePlaceByCoords(geo.latitude, geo.longitude)
  const currentPlace = experiencePlace.type === 'currentLocation' ? geoPlace : selectedPlace
  const prevPlace = usePrevious(currentPlace)

  // Count-only stream — filters.total decides whether this place has experiences.
  const list = useExperienceSearchList({ placeId: currentPlace?.id, sortBy: 'recommended', countOnly: true })

  useEffect(() => {
    const shouldFallback = currentPlace === null
      || (!list.fetching && getExperienceListOfferCount(list) === 0)

    if (!shouldFallback) {
      return
    }

    // a 'null' current place means we tried to fetch it and a place for that ID didn't exist.
    // So fallback to something we know exists
    // Types levels: Selected Place -> Current Region -> Anywhere
    const fallbackRegionPlace = getDefaultRegionPlace(geo.currentRegionCode)
    if (currentPlace?.id !== fallbackRegionPlace.id) {
      dispatch(setExperiencePlace('region', { regionCode: geo.currentRegionCode, userSelected: false }))
    } else {
      dispatch(setExperiencePlace('place', { placeId: Places.Anywhere.id, userSelected: false }))
    }
  // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [list, currentPlace])

  return currentPlace || prevPlace
}

export default useSmartExperiencePlace
